
import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { MstCsDeliveryGuideVO } from '@/views/biz/product/vo/product.vo';

declare type CsItem = {
    itemCd: string;
    itemNm: string;
}

@Component
export default class ProductDeliveryInfo2 extends Vue {
    @Prop() productType!: string;

    csInfos: Array<MstCsDeliveryGuideVO> = [];

    // computed
    get csItems(): Array<CsItem> {
        const result: Array<CsItem> = [];
        // 중복 제거 set
        const itemCdSet: Set<string> = new Set();

        // itemCd와 itemNm만 발라냄
        this.csInfos.forEach((v: MstCsDeliveryGuideVO) => {
            itemCdSet.has(v.itemCd) || result.push({itemCd: v.itemCd, itemNm: v.itemNm});
            itemCdSet.add(v.itemCd);
        });
        return result;
    }
    
    // methods

    getCsinfosByItemCd(itemCd: string){
        return this.csInfos.filter((v)=>{return v.itemCd == itemCd});
    }


    // initialized events
    created(): void {
      axios.get(`/product/cs/${this.productType}`)
      .then((r) => {
          this.csInfos = r.data as Array<MstCsDeliveryGuideVO>;
      });
    }
}
